const replace = (previous: string, current: string) => previous.replace(/%s/, current);

export const interpolate = (template: string, argumentArray: string[]) =>
    argumentArray === undefined ? template : argumentArray.reduce(replace, template);
